import { ContextApi } from "@pancakeswap/localization";
import { FooterLinkType } from "../../../components/Footer/types";

export const footerLinks: (t: ContextApi["t"]) => FooterLinkType[] = (t) => [
  /* {
    /*
    label: t("Ecosystem"),
    items: [
      {
        label: t("Trade"),
        href: "https://pulsex.mypinata.cloud/ipfs/bafybeidea3ibq4lu5t6vk6ihp4iuznjb3ltsdm5y2shv4atxgyd3d33aim/#/?outputCurrency=0x97f7259931f98CC64EbCd993fdE03d71716f3E07",
      },
      {
        label: t("Earn"),
        href: "https://app.squirrelsociety.vip/farms",
      },
      {
        label: t("Game"),
        href: "https://pancakeswap.games/",
      },
      {
        label: t("NFT"),
        href: "https://app.squirrelsociety.vip/nfts",
      },
      {
        label: t("Tokenomics"),
        href: "https://docs.app.squirrelsociety.vip/governance-and-tokenomics/cake-tokenomics",
      },
      {
        label: t("Litepaper"),
        href: "https://assets.app.squirrelsociety.vip/litepaper/v2litepaper.pdf",
      },
      {
        label: t("CAKE Emission Projection"),
        href: "https://analytics.app.squirrelsociety.vip/",
      },
      {
        label: t("Merchandise"),
        href: "https://merch.app.squirrelsociety.vip/",
      },
    ],
  },
  {
    label: "Business",
    items: [
      {
        label: t("Farms and Syrup Pools"),
        href: "https://docs.app.squirrelsociety.vip/ecosystem-and-partnerships/business-partnerships/syrup-pools-and-farms",
      },
      {
        label: t("IFO"),
        href: "https://docs.app.squirrelsociety.vip/ecosystem-and-partnerships/business-partnerships/initial-farm-offerings-ifos",
      },
      {
        label: t("NFT Marketplace"),
        href: "https://docs.app.squirrelsociety.vip/ecosystem-and-partnerships/business-partnerships/nft-market-applications",
      },
    ],
  },
  {
    label: t("Developers"),
    items: [
      {
        label: t("Contributing"),
        href: "https://docs.app.squirrelsociety.vip/developers/contributing",
      },
      {
        label: t("Github"),
        href: "https://github.com/pancakeswap",
      },
      {
        label: t("Bug Bounty"),
        href: "https://docs.app.squirrelsociety.vip/developers/bug-bounty",
      },
      {
        label: t("v4"),
        href: "https://app.squirrelsociety.vip/v4",
      },
    ],
  },
  {
    label: t("Support"),
    items: [
      {
        label: t("Contact"),
        href: "https://docs.app.squirrelsociety.vip/contact-us/customer-support",
      },
      {
        label: t("Troubleshooting"),
        href: "https://docs.app.squirrelsociety.vip/readme/help/troubleshooting",
      },
      {
        label: t("Documentation"),
        href: "https://docs.app.squirrelsociety.vip/",
      },
    ],
  },
  {
    label: t("About"),
    items: [
      {
        label: t("Terms Of Service"),
        href: "https://app.squirrelsociety.vip/terms-of-service",
      },
      {
        label: t("Blog"),
        href: "https://blog.app.squirrelsociety.vip/",
      },
      {
        label: t("Brand Assets"),
        href: "https://docs.app.squirrelsociety.vip/ecosystem-and-partnerships/brand",
      },
      {
        label: t("Careers"),
        href: "https://docs.app.squirrelsociety.vip/team/become-a-chef",
      },
    ],
  },
  */
];
